/* IMAGE MAP */
export const ADD_IMAGES_TO_MAP = "ADD_IMAGES_TO_MAP"
export const CLEAR_IMAGE_MAP = "CLEAR_IMAGE_MAP"
export const FETCH_MISSING_IMAGES = "FETCH_MISSING_IMAGES"


